"use client";

import { GenericFormPage, type GenericFormConfig } from "@admin/_components/generic-form-page";

const RELATIONSHIP_OPTIONS = [
  { value: "husband", label: "Husband" },
  { value: "wife", label: "Wife" },
  { value: "son", label: "Son" },
  { value: "daughter", label: "Daughter" },
  { value: "father", label: "Father" },
  { value: "mother", label: "Mother" },
  { value: "brother", label: "Brother" },
  { value: "sister", label: "Sister" },
  { value: "friend", label: "Friend" },
  { value: "colleague", label: "Colleague" },
  { value: "relative", label: "Relative" },
  { value: "other", label: "Other" },
];

const config: GenericFormConfig = {
  title: "Perennial Member",
  addTitle: "Add Member",
  editTitle: "Edit Member",
  fetchEndpoint: "user/fetch-user-by-id",
  addEndpoint: "user/add-aditonal-member",
  editEndpoint: "user/update_perenial_memeber",
  backPath: "/admin/perennial/members",
  fields: [
    { key: "firstname", label: "First Name", type: "text", required: true },
    { key: "lastname", label: "Last Name", type: "text", required: true },
    { key: "email", label: "Email", type: "email", required: true },
    { key: "phone", label: "Phone", type: "text" },
    {
      key: "relationship_with_family",
      label: "Relationship",
      type: "select",
      options: RELATIONSHIP_OPTIONS,
    },
    { key: "relationship_status", label: "Relationship Status", type: "text", placeholder: "e.g. Married, Single..." },
    { key: "focus_on_specific_relationships", label: "Focus on Specific Relationships", type: "switch" },
  ],
};

export default function AddPerennialMemberPage() {
  return <GenericFormPage config={config} />;
}
